// extracted by mini-css-extract-plugin
export default {"charts-wrapper":"charts_charts-wrapper__KE6EY"};